import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-element"

export default class extends Controller {
    static targets = ["elementDefault", "elementTogglable", "btnDefault", "btnTogglable"]

    connect() {
    }

    btnDefaultTargetConnected(target) {
        target.addEventListener('click', () => {
            this.elementDefaultTarget.classList.add('tw:hidden');
            this.elementTogglableTarget.classList.remove('tw:hidden');
        });
    }

    btnTogglableTargetConnected(target) {
        target.addEventListener('click', () => {
            this.elementDefaultTarget.classList.remove('tw:hidden');
            this.elementTogglableTarget.classList.add('tw:hidden');
        });
    }
}